<template>
  <div class="toggle">
    <div class="toggle-header" @click="toggle">
      <i class="icon-wrap"
        :class="{
          'arrow-up': !animatedArrow && toggled,
          'arrow-down': animatedArrow || !animatedArrow && !toggled,
          'open': animatedArrow && toggled,
          'close': animatedArrow && !toggled,
          'right': animatedArrow && animationRight,
        }"
      ></i>
      <h4>
        {{ title }}
        <slot name="title"></slot>
      </h4>
    </div>
    <transition
      @before-enter="setHeight"
      @enter="restoreHeight"
      @before-leave="restoreHeight"
      @leave="setHeight"
    >
      <div class="content-wrap" v-if="toggled">
        <div class="content-wrap-inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    isToggled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    animatedArrow: {
      type: Boolean,
      default: false
    },
    animationRight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toggled: false
    }
  },
  created () {
    this.toggled = this.isToggled
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    toggle () {
      this.toggled = !this.toggled
      this.$emit('toggle', this.toggled, this.$el)
    },
    setHeight (el) {
      el.style.height = 0
    },
    onResize () {
      this.toggled = false
    },
    restoreHeight (el) {
      if (this.toggled) {
        setTimeout(() => {
          el.style.height = el.scrollHeight + 'px'
        })
      } else {
        el.style.height = el.scrollHeight + 'px'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../sass/variables'

.toggle
  &-header
    display: flex
    cursor: pointer
    padding: 1em 0
    border-bottom: 1px solid $text-grey
    i
      margin-right: 1em
      &.open
        &:after
          transform: rotate(90deg)
          transition-duration: 0.3s
        &.right
          &:after
            transform: rotate(90deg)
            transition-duration: 0.3s
      &.close
        &:after
          transform: rotate(-90deg)
          transition-duration: 0.3s
        &.right
          &:after
            transform: rotate(270deg)
            transition-duration: 0.3s
  .content-wrap
    overflow: hidden
    transition: 0.4s
    &-inner
      overflow-wrap: break-word
</style>



// WEBPACK FOOTER //
// src/components/ToggleContent.vue